import React, { useState } from 'react';
import './GuideAdvice.scss';
import Pagination from '../common/Pagination';

const GuideAdvice = () => {
  // 페이지네이션 설정
  const [currentPage, setCurrentPage] = useState(1);
  const advicesPerPage = 2;

  const adviceList = [
    {
      author: '재학생 A',
      detail: '전기전자컴퓨터공학부 2학년',
      avatar: '👨‍💻',
      tags: ['새내기조언', '학업', '적응'],
      content: `처음에는 모든 수업이 어렵게 느껴질 수 있지만, 너무 조급해하지 않아도 됩니다. 
      1학년 때는 성적보다도 다양한 과목을 경험해보며 내가 무엇에 흥미를 느끼는지 찾는 시간이 더 중요하다고 생각합니다. 
      주변 친구들과 스터디를 하면서 함께 버티다 보면 어느 순간 익숙해지고, 그 과정 자체가 큰 성장으로 남습니다.`,
    },
    {
      author: '재학생 B',
      detail: '생명과학부 3학년',
      avatar: '👩‍🔬',
      tags: ['기숙사생활', '동아리', '학교생활'],
      content: `새내기 때는 낯설고 어색한 게 당연합니다. 
      기숙사 생활과 동아리 활동에 조금만 용기를 내서 참여해보면 생각보다 빨리 친해질 수 있습니다. 
      공부도 중요하지만, 사람들과의 관계와 경험이 대학 생활을 더 단단하게 만들어준다는 걸 꼭 기억했으면 좋겠습니다.`,
    },
    {
      author: '재학생 C',
      detail: '기계공학부 3학년',
      avatar: '👨‍🎓',
      tags: ['전공선택', '진로', '도전'],
      content: `전공을 정하기 전까지는 최대한 많이 들어보고, 직접 경험해보는 걸 추천합니다. 
      막연한 이미지로 판단하기보다 수업을 듣고 교수님과 이야기해보면 생각이 달라질 수 있습니다. 
      실패해도 괜찮으니, 새내기 때는 조금 더 많이 도전해보셨으면 합니다.`,
    },
    {
      author: '졸업생 A',
      detail: 'GIST 대학원 박사과정',
      avatar: '👨‍🔬',
      tags: ['연구', '대학원', '교환학생'],
      content: `저는 지스트에서 연구실 인턴과 교환학생 경험을 통해 연구가 제 적성에 맞는지 직접 확인할 수 있었습니다. 
      학부 시절 쌓은 기초 역량과 우수한 연구 환경 덕분에 현재는 GIST 대학원 박사과정을 이어가고 있습니다. 
      함께 공부하고 생활했던 친구들과의 시간 역시 제게 큰 자산으로 남아 있습니다.`,
    },
    {
      author: '졸업생 B',
      detail: '타 대학원 석사 후 대기업 근무',
      avatar: '👩‍💼',
      tags: ['진로탐색', '인턴십', '글로벌역량'],
      content: `저는 지스트에서 연구실과 기업 인턴, 교환학생 경험을 하며 다양한 진로를 탐색할 수 있었습니다. 
      전공을 선언하기 전까지 충분히 고민하고 도전할 수 있었던 시간이 지금의 진로를 선택하는 데 큰 도움이 되었습니다. 
      학부 시절의 연구 경험과 영어 역량은 현재 대기업에서 근무하는 데에도 중요한 밑거름이 되고 있습니다.`,
    },
  ];

  // 페이지네이션 로직
  const totalAdvices = adviceList.length;
  const totalPages = Math.ceil(totalAdvices / advicesPerPage);
  
  const indexOfLastAdvice = currentPage * advicesPerPage;
  const indexOfFirstAdvice = indexOfLastAdvice - advicesPerPage;
  const currentAdvices = adviceList.slice(indexOfFirstAdvice, indexOfLastAdvice);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <div className="GuideAdvice">
      {/* Hero 섹션 */}
      <section className="sec-guide-hero">
        <div className="GuideHero">
          <div className="box-main">
            <h1 className="guide-title">선배 GISTian의 조언</h1>
            <p className="guide-desc">
              먼저 경험한 선배들의 생생한 조언을 들어보세요.
            </p>
          </div>
        </div>
      </section>

      {/* 조언 섹션 */}
      <section className="sec-advice">
        <div className="AdviceSection">
          <div className="box-main">
            <div className="box-header">
              <h2 className="advice-title">선배들의 조언</h2>
              <p className="advice-subtitle">
                GIST 재학생들이 전하는 대학 생활 팁
              </p>
            </div>

            <div className="box-advices">
              {currentAdvices.map((advice, index) => (
                <article key={indexOfFirstAdvice + index} className="art-advice">
                  <div className="box-advice-header">
                    <div className="box-author">
                      <div className="box-avatar">{advice.avatar}</div>
                      <div className="box-author-info">
                        <div className="author-name">{advice.author}</div>
                        <div className="author-detail">{advice.detail}</div>
                      </div>
                    </div>
                  </div>
                  <div className="advice-content">
                    {advice.content.split('\n').map((line, idx) => (
                      <p key={idx}>{line.trim()}</p>
                    ))}
                  </div>
                  <div className="box-tags">
                    {advice.tags.map((tag, idx) => (
                      <span key={idx} className="tag">
                        #{tag}
                      </span>
                    ))}
                  </div>
                </article>
              ))}
            </div>

            {/* 페이지네이션 */}
            {totalPages > 1 && (
              <div className="box-pagination">
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default GuideAdvice;
